import React, { useEffect } from 'react'
import {Link, useNavigate} from 'react-router-dom';
import { login } from '../../controller/Control'
import { Button, Checkbox, Form, Input } from 'antd';
import Logo from '../../assets/logo.png'
import './styles.css'

type FieldType = {
	user?: string;
	pass?: string;
};

const Login: React.FC = () => {

	const navigate = useNavigate()

	const getLoginFunction = async(values: {user: string, pass: string}) => {
		const getData = await login(`${process.env.REACT_APP_API_SERVER}/users/login` || 'localhost:3000', values)
		if(getData === 401){
			alert('Error de usuario o contraseña')
		}
		if(getData && getData.token){
			sessionStorage.setItem('userData', JSON.stringify(getData));
			navigate('/home')
		}
	}
	return (
		<div className={`flex w-screen h-screen flex-col justify-center gap-1 items-center homePage`}>
			<div className='border-2 border-red-300 p-10 rounded-xl bg-[rgba(255,203,219,0.5)]'>
				<div className='flex justify-center'>
					<img className='h-32' src={Logo}/>
				</div>
				<div>
					<Form
						name="login"
						layout='vertical'
						onFinish={getLoginFunction}
						autoComplete="off"
					>
						<Form.Item<FieldType>
							label="Usuario"
							name="user"
							rules={[{ required: true, message: 'Por favor digita un usuario' }]}
						>
							<Input />
						</Form.Item>

						<Form.Item<FieldType>
							label="Contraseña"
							name="pass"
							rules={[{ required: true, message: 'Por favor digita una contraseña' }]}
						>
							<Input.Password />
						</Form.Item>
						<Button type='link' className='p-0' onClick={() => navigate('/resetPassword')}>Olvidé la Contraseña</Button>
						<Form.Item className='mt-2'>
							<Button type="primary" htmlType="submit">
								Ingresar
							</Button>
						</Form.Item>
					</Form>
				</div>
			</div>
		</div>
	)
}

export default Login